import React from "react";
import formiLogo from "../pictures/formilogo_color_full1.svg";
function FormiLogoFull() {
  return <img src={formiLogo} alt="formi" className="formiLogo" />;
}

export default FormiLogoFull;
